import { OEM_CONSTANTS } from "../constants/oemConstants";

const initialState = {
  partners: [],
  scanTypes: [],
  oemNames: [],
  loading: false,
  formLoading: false,
  scanTypesLoading: false,
  oemNamesLoading: false,
  error: null,
  success: false,
  passwordResetStatus: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10
  }
};

const oemReducer = (state = initialState, action) => {
  switch (action.type) {
    case OEM_CONSTANTS.ADD_OEM_REQUEST:
    case 'EDIT_OEM_REQUEST':
    case 'DELETE_OEM_REQUEST':
      return {
        ...state,
        formLoading: true,
        error: null
      };

    case OEM_CONSTANTS.GET_OEM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case OEM_CONSTANTS.ADD_OEM_SUCCESS:
      return {
        ...state,
        formLoading: false,
        success: true,
        error: null
      };

    case 'EDIT_OEM_SUCCESS':
    case 'DELETE_OEM_SUCCESS':
      return {
        ...state,
        formLoading: false,
        success: true,
        error: null
      };

    case OEM_CONSTANTS.GET_OEM_SUCCESS:
      return {
        ...state,
        loading: false,
        partners: action.payload.response || [],
        pagination: action.payload.pagination || state.pagination,
        success: false,
        error: null
      };

    case OEM_CONSTANTS.ADD_OEM_FAILURE:
    case 'EDIT_OEM_FAILURE':
    case 'DELETE_OEM_FAILURE':
      return {
        ...state,
        formLoading: false,
        error: action.payload
      };

    case OEM_CONSTANTS.GET_OEM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case OEM_CONSTANTS.GET_SCAN_TYPES_REQUEST:
      return {
        ...state,
        scanTypesLoading: true,
        error: null
      };

    case OEM_CONSTANTS.GET_SCAN_TYPES_SUCCESS:
      return {
        ...state,
        scanTypesLoading: false,
        scanTypes: action.payload.response || [],
        error: null
      };

    case OEM_CONSTANTS.GET_SCAN_TYPES_FAILURE:
      return {
        ...state,
        scanTypesLoading: false,
        error: action.payload
      };

    case OEM_CONSTANTS.GET_OEM_NAMES_REQUEST:
      return {
        ...state,
        oemNamesLoading: true,
        error: null
      };

    case OEM_CONSTANTS.GET_OEM_NAMES_SUCCESS:
      return {
        ...state,
        oemNamesLoading: false,
        oemNames: action.payload.response || [],
        error: null
      };

    case OEM_CONSTANTS.GET_OEM_NAMES_FAILURE:
      return {
        ...state,
        oemNamesLoading: false,
        error: action.payload
      };

    case 'RESET_OEM_PASSWORD_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };

    case 'RESET_OEM_PASSWORD_SUCCESS':
      return {
        ...state,
        loading: false,
        success: true,
        passwordResetStatus: action.payload?.status || 200,
        error: null
      };

    case 'RESET_OEM_PASSWORD_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case 'CLEAR_OEM_PASSWORD_STATUS':
      return {
        ...state,
        passwordResetStatus: null
      };

    case 'RESEND_VERIFICATION_EMAIL_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };

    case OEM_CONSTANTS.RESEND_VERIFICATION_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null
      };

    case OEM_CONSTANTS.RESEND_VERIFICATION_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default oemReducer;